import * as esriLoader from 'esri-loader';

export function bootstrapJSAPI(portalUrl, jsapiUrl, use3D) {
  return new Promise((resolve, reject) => {
    if (esriLoader.isLoaded()) {
      resolve();
      return;
    }
    const basename = process.env.PUBLIC_URL;
    const options = {
      url: jsapiUrl,
      dojoConfig: {
        has: {
          "graphite-js-3": false,
          "esri-featurelayer-webgl": (supportsWebGL() && !use3D) ? 1 : 0
        },
        async: true,
        packages: [{
          // location: 'https://arcgis.github.io/graphite-js/src',
          location: basename + '/graphite',
          name: 'graphite'
        }]
      }
    };

    esriLoader.loadScript(options)
      .then(() => {
        initApi(portalUrl).then(
          success => resolve(),
          error => reject(error)
        );
      })
      .catch(err => {
        reject(err);
      });

  });
}

export function createView(node, basemapId, use3D, viewOptions) {
  return new Promise((resolve, reject) => {
    if (!esriLoader.isLoaded()) {
      reject('JSAPI is not yet loaded');
      return;
    }

    initView(node, basemapId, use3D, viewOptions).then(
      response => {
        postInitView(response.view);
        resolve(response);
      },
      error => {
        reject(error);
      }
    );

  });
}

export function createSearch(view, node, searchOptions) {
  return new Promise((resolve, reject) => {
    esriLoader.loadModules(['esri/widgets/Search'])
      .then(([Search]) => {
        let options = Object.assign({}, {
          view: view,
          container: document.createElement("searchDiv"),
          includeDefaultSources: false
        }, searchOptions);

        let search = new Search(options);
        view.ui.add(search, {
          position: "top-right"
        });
        
        view.ui.add("measurementTopbar", "top-right");

        resolve(search);
      });
  });
}

export function createLegend(view, originLayer, viirsLayer) {
  return new Promise((resolve, reject) => {
    esriLoader.loadModules(['esri/widgets/Legend', 'esri/widgets/Expand','esri/widgets/ScaleBar'])
      .then(([Legend, Expand, ScaleBar]) => {

        let incidentsLegend = new Legend({
          container: document.createElement("div"),
          view: view,
          layerInfos: [{
            layer: originLayer,
            title: "Incidents"
          },
          {
            layer: viirsLayer,
            title: "VIIRS"
          }]
        });

        var scaleBar = new ScaleBar({
        view: view,
        unit: "dual" // The scale bar displays both metric and non-metric units.
      });

      // Add the widget to the bottom left corner of the view
      view.ui.add(scaleBar, {
        position: "bottom-right"
      });

        const legendExpand = new Expand({
          expandIconClass: "esri-icon-layer-list", // see https://developers.arcgis.com/javascript/latest/guide/esri-icon-font/
          expandTooltip: "Show Legend",
          view: view,
          content: incidentsLegend.domNode
        });
        view.ui.add(legendExpand, "bottom-left");

        incidentsLegend.style = "card";
        incidentsLegend.layout = "side-by-side";
        resolve(incidentsLegend);
      });
  });
}

export function createLayerList(view, portalItemIds, addLayerFunction,removeLayerFunction) {
  return new Promise((resolve, reject) => {
    esriLoader.loadModules(['esri/widgets/LayerList', 'esri/widgets/Expand', 'esri/support/actions/ActionButton'])
      .then(([LayerList, Expand, ActionButton]) => {

        let layerList = new LayerList({
          container: document.createElement("div"),
          view: view,
          listItemCreatedFunction:  function (event) 
          {
            if (event.item.parent !== null && event.item.parent.title === 'User Layers')  
            {
              event.item.actionsSections = [
                [
                  {
                    title: "Remove Layer",
                    className: "esri-icon-trash",
                    id: "remove-user-layer"
                  }
                ]
              ];
            } 
            else if (event.item.title !== "User Layers")  
            {
              return false;
            }
            else {
              event.item.actionsSections = [
                [
                  {
                    title: "Add Layer",
                    className: "esri-icon-settings2",
                    id: "add-user-layer"
                  }
                ]
              ];
            }
            }
          });

            layerList.on("trigger-action", (event) => 
            {
              if (event.action.id === "add-user-layer") 
              {
                  addLayerFunction();
                  return;
              }

              if (event.action.id === "remove-user-layer") 
              {
                  removeLayerFunction(event);
                  return;
              }
            });


        const layerListExpand = new Expand({
          expandIconClass: "esri-icon-layers",
          expandTooltip: "Show Layer List",
          view: view,
          content: layerList.domNode
        });

        view.ui.add(layerListExpand, "top-left");

        /*const deleteAction = new ActionButton({
          id: "delete-feature",
          title: "Delete Feature",
          icon: "trash"
         }); */

        view.ui.add("pauseTopbar", "top-left");

        resolve(layerList);
      });
  });
}

function initApi(portalUrl) {
  return new Promise((resolve, reject) => {
      esriLoader.loadModules(['esri/identity/IdentityManager', 'esri/config'])
        .then(([IdentityManager, esriConfig]) => {
          //esriConfig.request.corsEnabledServers.push("nifc.maps.arcgis.com");
          resolve();
        });

  });
}

function initView(node, basemapId, use3D, viewOptions) {
  return new Promise((resolve, reject) => {
    esriLoader.loadModules([
        'esri/Basemap',
        'esri/Map',
        'esri/views/SceneView',
        'esri/views/MapView',
        'dojo/dom-construct'
      ])
      .then(([Basemap, Map, SceneView, MapView, domConstruct]) => {
        const basemap = (!basemapId) ? 'topo' : new Basemap({
          portalItem: {
            id: basemapId
          }
        });
        const map = new Map({
          basemap: basemap
          // ground: 'world-elevation'
        });

        const viewConfig = Object.assign({}, {
            map: map,
            container: node
          },
          viewOptions
        );

        if (use3D && supportsWebGL()) {
          const sceneView = new SceneView(viewConfig);
          sceneView.when(
            response => {
              resolve({
                view: response
              });
            },
            //webgl check is not bullet proof. If failure on 3D go with 2D
            error => {
              domConstruct.empty(node);
              let view = new MapView(viewConfig);

              view.when(
                response => {
                  resolve({
                    view: response
                  });
                },
                error => {
                  reject(error)
                }
              );
            }
          );
        } else {
          const view = new MapView(viewConfig);
          view.when(
            response => {
              resolve({
                view: response
              });
            },
            error => {
              reject(error)
            }
          );
        }

      });
  });
}

function postInitView(view) {
  esriLoader.loadModules(['esri/widgets/BasemapGallery', 'esri/widgets/Expand', 'esri/Basemap', 'esri/widgets/BasemapGallery/support/LocalBasemapsSource'])
    .then(([BasemapGallery, Expand, Basemap, LocalBasemapsSource]) => 
    {
      if (view.type === '2d' && supportsWebGL()) 
      {
        view.map.basemap = 'topo-vector'
      }
      view.ui.remove("navigation-toggle");


      const basemapGallery = new BasemapGallery({
        view: view,
        container: document.getElementById("basemapGalleryDiv"),
        source: new LocalBasemapsSource({
         basemaps: [
           new Basemap({
             portalItem: {
               id: "42e152344ffb46f28ba49d7f4d0b91ab"
             },
             title: "USA Topo Maps"
           }), 
           Basemap.fromId("topo-vector"),
           Basemap.fromId("satellite")
            // create a basemap from a well known id
         ]
      })
      });

      const bgExpand = new Expand({
        view: view,
        content: basemapGallery
      });

      view.ui.add(bgExpand, 'bottom-right');
    });
}



function supportsWebGL() {
  // Create canvas element. The canvas is not added to the
  // document itself, so it is never displayed in the
  // browser window.
  var canvas = document.createElement("canvas");
  // Get WebGLRenderingContext from canvas element.
  var gl = canvas.getContext("webgl") ||
    canvas.getContext("experimental-webgl");
  // Report the result.
  if (gl && gl instanceof WebGLRenderingContext) {
    return true;
  } else {
    return false;
  }
}
